// extracted by mini-css-extract-plugin
export default {"Policy":"PolicyEn_Policy__XQGIT"};